// extracted by mini-css-extract-plugin
export default {"message":"classes@desktop_message__rhYd-","icon":"classes@desktop_icon__V-Vta","messageContent":"classes@desktop_messageContent__-TJZX"};